import { RequestStatus } from '@shared/model/request';

export const DISABLED_STATUSES: RequestStatus[] = [
    RequestStatus.Canceled,
    RequestStatus.Completed,
    RequestStatus.OnPayment,
    RequestStatus.OrderReject,
    RequestStatus.Request_reject,
    RequestStatus.OrderForming,
];
